function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.6
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#paint0_linear)",
  d: "M15.6165 2.44594C9.35186 0.406856 2.62705 3.8223 0.589353 10.0842C-1.44973 16.3488 1.97261 23.0722 8.22899 25.1058C14.4895 27.1476 21.2143 23.7294 23.2534 17.4689C25.291 11.2015 21.8728 4.48364 15.6165 2.44594Z",
  clipRule: "evenodd",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#paint1_linear)",
  d: "M15.1016 4.01658C9.70769 2.26269 3.91839 5.20698 2.15899 10.5953C0.405104 15.9878 3.35073 21.7813 8.74051 23.5324C14.133 25.2918 19.9278 22.3489 21.6803 16.9578C23.437 11.5612 20.4928 5.77459 15.1016 4.01658Z",
  clipRule: "evenodd",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#paint2_linear)",
  d: "M20.1742 12.9L17.438 8.1688C17.4159 8.10405 17.3759 8.04893 17.325 7.99381C17.1927 7.80919 16.9681 7.69482 16.7284 7.69482C16.4831 7.69482 16.2848 7.80919 16.1277 7.9883L16.0188 8.17431L13.0718 13.2871L12.9382 13.5227C12.9217 13.5985 12.8914 13.6839 12.8914 13.7749C12.8914 13.8685 12.9217 13.9485 12.9382 14.0353L13.0718 14.2612L14.7541 17.182C14.8381 17.3046 14.8601 17.4342 14.8601 17.5582C14.8601 17.8199 14.732 18.0734 14.4854 18.2153C14.1272 18.4289 13.6587 18.3021 13.4576 17.9398L12.5924 16.4752L12.5331 16.354C12.3995 16.1694 12.1708 16.0426 11.9186 16.0426C11.6707 16.0426 11.4406 16.1694 11.3097 16.354L11.2491 16.4752L9.10251 20.1649L9.09561 20.1924C9.03086 20.3082 8.97852 20.4473 8.97852 20.5947C8.97852 21.0108 9.32707 21.3538 9.74316 21.3538H15.2817C15.8273 21.3538 16.5244 20.9612 16.7862 20.4803L20.1741 14.6497C20.4442 14.173 20.4442 13.3795 20.1742 12.9Z",
  clipRule: "evenodd",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#paint3_linear)",
  d: "M10.8986 14.0354C10.9179 13.9486 10.9523 13.8687 10.9523 13.775C10.9523 13.6786 10.9193 13.5987 10.8986 13.5229L10.7718 13.2873L9.08548 10.372C9.00282 10.2452 8.97801 10.1102 8.97801 9.98893C8.97801 9.72715 9.10751 9.46399 9.35276 9.32898C9.71372 9.12094 10.1766 9.24493 10.3861 9.61279L11.2486 11.0677L11.3092 11.1931C11.4401 11.386 11.6701 11.5127 11.9181 11.5127C12.1703 11.5127 12.399 11.3846 12.5326 11.1931L12.5919 11.0691L14.7356 7.37811L14.7453 7.35881C14.8128 7.24171 14.8638 7.09703 14.8638 6.94685C14.8638 6.53076 14.5152 6.19873 14.1184 6.19873H8.55095C8.01226 6.19873 7.31649 6.5845 7.05194 7.06945L3.66959 12.8987C3.39402 13.3781 3.39402 14.1718 3.66959 14.6484L6.40305 19.3796C6.43337 19.443 6.46507 19.505 6.51052 19.5573C6.64969 19.7392 6.87287 19.8604 7.11674 19.8604C7.34958 19.8604 7.56036 19.7433 7.71055 19.5628L7.82491 19.3741L10.7692 14.2613L10.8986 14.0354Z",
  clipRule: "evenodd",
  fillRule: "evenodd"
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#paint4_linear)",
  d: "M29.9686 0.681979C22.7285 -1.67535 14.958 2.27467 12.6034 9.50924C10.2461 16.7493 14.2002 24.5198 21.432 26.8703C28.6666 29.2317 36.4399 25.2776 38.7958 18.0458C41.1504 10.8016 37.199 3.03653 29.9686 0.681979Z",
  clipRule: "evenodd",
  fillRule: "evenodd"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#paint5_linear)",
  d: "M29.3732 2.49802C23.1402 0.46722 16.4485 3.87165 14.4149 10.0991C12.3896 16.3334 15.7927 23.0306 22.0215 25.0518C28.2531 27.0881 34.9503 23.6837 36.9756 17.4507C39.0078 11.215 35.6033 4.52609 29.3732 2.49802Z",
  clipRule: "evenodd",
  fillRule: "evenodd"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#paint6_linear)",
  d: "M35.2342 12.7635L32.0723 7.29795C32.0461 7.22079 31.9992 7.15604 31.9414 7.09403C31.7885 6.88321 31.5294 6.75098 31.2511 6.75098C30.9673 6.75098 30.7386 6.88325 30.5567 7.08579L30.4314 7.30346L27.0269 13.2099L26.8726 13.4813C26.8547 13.5653 26.8175 13.6673 26.8175 13.7733C26.8175 13.8835 26.8547 13.9759 26.8726 14.0751L27.0269 14.3368L28.9709 17.711C29.0688 17.8542 29.0949 18.0003 29.0949 18.1463C29.0949 18.4522 28.9447 18.7415 28.6596 18.9082C28.2462 19.1535 27.7048 19.0033 27.4719 18.5872L26.4717 16.894L26.4028 16.7548C26.2499 16.5412 25.9867 16.3938 25.6919 16.3938C25.4067 16.3938 25.1408 16.5399 24.9892 16.7548L24.9176 16.894L22.4376 21.1581L22.4294 21.187C22.355 21.3234 22.293 21.4846 22.293 21.6541C22.293 22.1349 22.6966 22.5317 23.1775 22.5317H29.5799C30.2095 22.5317 31.0155 22.0784 31.3186 21.5232L35.2328 14.7846C35.547 14.2322 35.547 13.3201 35.2342 12.7635Z",
  clipRule: "evenodd",
  fillRule: "evenodd"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#paint7_linear)",
  d: "M24.5146 14.0764C24.5394 13.9785 24.5766 13.8849 24.5766 13.7747C24.5766 13.6617 24.5394 13.5666 24.5146 13.4826L24.3672 13.2112L22.4218 9.84255C22.3253 9.69652 22.295 9.54083 22.295 9.39892C22.295 9.09308 22.4452 8.7941 22.7276 8.63567C23.1465 8.39593 23.6824 8.54473 23.9222 8.96497L24.921 10.6458L24.9927 10.7891C25.1429 11.0123 25.4101 11.1625 25.6953 11.1625C25.9888 11.1625 26.2519 11.0137 26.4063 10.7891L26.4751 10.6458L28.9523 6.37896L28.9633 6.35966C29.0405 6.22465 29.0997 6.05517 29.0997 5.8816C29.0997 5.40216 28.6974 5.02051 28.2386 5.02051H21.8059C21.1832 5.02051 20.3786 5.4614 20.0741 6.02489L16.1654 12.7635C15.8485 13.3187 15.8485 14.2308 16.1654 14.786L19.3246 20.2515C19.3604 20.3259 19.3976 20.3962 19.4486 20.4568C19.6084 20.6648 19.8674 20.8053 20.1485 20.8053C20.4185 20.8053 20.6624 20.6689 20.8374 20.4623L20.9682 20.246L24.3713 14.3382L24.5146 14.0764Z",
  clipRule: "evenodd",
  fillRule: "evenodd"
});

var _ref7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  gradientUnits: "userSpaceOnUse",
  y2: -12.7601,
  x2: 1.39402,
  y1: -18.8699,
  x1: 56.1393,
  id: "paint0_linear"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#17E2CF"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5181FD",
  offset: 1
})), /*#__PURE__*/React.createElement("linearGradient", {
  gradientUnits: "userSpaceOnUse",
  y2: -7.24956,
  x2: -13.5166,
  y1: -12.5132,
  x1: 33.6352,
  id: "paint1_linear"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#173048"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5181FD",
  offset: 1
})), /*#__PURE__*/React.createElement("linearGradient", {
  gradientUnits: "userSpaceOnUse",
  y2: 23.1178,
  x2: 12.526,
  y1: 10.5462,
  x1: 2.7117,
  id: "paint2_linear"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#17E2CF"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5181FD",
  offset: 1
})), /*#__PURE__*/React.createElement("linearGradient", {
  gradientUnits: "userSpaceOnUse",
  y2: 23.9475,
  x2: 11.0034,
  y1: 11.3747,
  x1: 1.18877,
  id: "paint3_linear"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#17E2CF"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5181FD",
  offset: 1
})), /*#__PURE__*/React.createElement("linearGradient", {
  gradientUnits: "userSpaceOnUse",
  y2: -16.8937,
  x2: 13.5328,
  y1: -23.9542,
  x1: 76.8011,
  id: "paint4_linear"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#17E2CF"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5181FD",
  offset: 1
})), /*#__PURE__*/React.createElement("linearGradient", {
  gradientUnits: "userSpaceOnUse",
  y2: -10.5267,
  x2: -3.69872,
  y1: -16.6089,
  x1: 50.7955,
  id: "paint5_linear"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#173048"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5181FD",
  offset: 1
})), /*#__PURE__*/React.createElement("linearGradient", {
  gradientUnits: "userSpaceOnUse",
  y2: 24.5778,
  x2: 26.3864,
  y1: 10.0425,
  x1: 15.051,
  id: "paint6_linear"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#17E2CF"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5181FD",
  offset: 1
})), /*#__PURE__*/React.createElement("linearGradient", {
  gradientUnits: "userSpaceOnUse",
  y2: 25.5267,
  x2: 24.6356,
  y1: 10.9998,
  x1: 13.2948,
  id: "paint7_linear"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#17E2CF"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5181FD",
  offset: 1
})));

var SvgIconMintNew = function SvgIconMintNew(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 40 28",
    height: 28,
    width: 40,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconMintNew, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Icon_Mint_New.47bd5b30.svg";
export { ForwardRef as ReactComponent };